import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut } from 'services/AuthService'
import { apiSignInDanone } from 'services/DanoneService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY, UI_VERSION } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import jwt_decode from 'jwt-decode';

import getOS from 'utils/operationSystem'

function useAuth() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

	const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signIn = async ({ userName, password, loginType = 'DPC' }) => {
        try {
			let resp;
			
			if (loginType === 'DANONE') {
				resp = await apiSignInDanone({ user_name: userName, password: password });
				if (resp.data.Content.token && resp.data.Content.token !== '') {
					dispatch(onSignInSuccess(resp.data.Content.token))
					dispatch(setUser({ 
						avatar: '', 
						userName: userName, 
						authority: [1], 
						positionNo: 1,
						email: userName,
						permissions: [1],
						loginType: loginType
					}))
					navigate(appConfig.danoneLoginPath);
					return {
						status: 'success',
						message: 'Giriş yapılıyor.'
					}
				} else{
					return {
						status: 'failed',
						message: 'Lütfen kullanıcı adı ve şifrenizi kontrol edin.'
					}
				}
			} else {
				resp = await apiSignIn({ user_name: userName, password: password });
				if (resp.data.token && resp.data.token !== '') {
					dispatch(onSignInSuccess(resp.data.token))
					dispatch(setUser({ 
						avatar: '', 
						userName: userName, 
						authority: [1], 
						positionNo: 1,
						email: userName,
						permissions: [1],
						loginType: loginType
					}))
					navigate(appConfig.firstLoginPath);
					return {
						status: 'success',
						message: 'Giriş yapılıyor.'
					}
				} else{
					return {
						status: 'failed',
						message: 'Lütfen kullanıcı adı ve şifrenizi kontrol edin.'
					}
				}
			}
		} catch (errors) {
			return {
                status: 'failed',
                message: errors?.response?.data?.error || errors.toString()
            }
		}
    }

    const handleSignOut = ()  => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
	}

    const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}
    
    return {
        authenticated: token && signedIn,
        signIn,
        signOut
    }
}

export default useAuth